import React, { useState } from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Card,
  Space,
  Button,
  Grid,
  Menu,
  Tabs,
  Breadcrumb,
  Progress,
  Collapse,
  Badge,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  HomeOutlined,
  CaretLeftOutlined,
  PlayCircleOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  BookOutlined,
  FolderOutlined,
  VideoCameraOutlined,
  RightOutlined,
  DownOutlined,
} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;
const { useBreakpoint } = Grid;

// ── Course Data ─────────────────────────────────────────────────────────────
const CATEGORIES = [
  {
    key: "cat-1",
    label: "IDDSI 0",
    type: "flat",
    colore: "#FFF",
    descrizione:
      "Fluidità simil acqua, defluisce velocemente e può essere bevuto con qualsiasi tipo di tettarella, tazza, cannuccia come più indicato per età e abilità.",
    test_di_flusso:
      "Utilizzando una siringa di portata 10 mL e lunghezza graduazione 61.5 mm, si fa scorrere il liquido all’interno contando 10 secondi. Allo scadere del tempo, il residuo rimasto nella siringa deve essere inferiore a 1 mL.",
    consiglio: "",

    subcategories: [
      {
        key: "1a",
        label: "Video Acqua",
        videoId: "81HbqxSetVs",
        duration: "0:47",
        completed: false,
      },
    ],
  },
  {
    key: "cat-2",
    label: "IDDSI 1",
    type: "flat",
    colore: "#717171",
    descrizione:
      "Densità superiore a quella dell’acqua, richiede un minimo sforzo in più nel bere rispetto al liquido (Livello 0). Fluisce attraverso una cannuccia, una siringa o una tettarella. Ha una viscosità simile alle formule anti-reflusso per lattanti, disponibili in commercio.",
    test_di_flusso:
      "Utilizzando una siringa di portata 10 mL e lunghezza graduazione 61.5 mm, si fa scorrere il liquido all’interno contando 10 secondi. Allo scadere del tempo il residuo rimasto nella siringa deve essere contenuto tra 1 e 4 mL.",
    consiglio:
      "Per la preparazione della bevanda addensata, può risultare più facile mescolare il tutto con una frusta, in modo da evitare la formazione di grumi. Inoltre è preferibile preparare delle quantità limitate di bevanda, seppur più scomodo. Infatti, se non  viene consumata nel breve periodo (qualche ora), c’è il rischio che cambi il livello della consistenza. ",
    subcategories: [
      {
        key: "2a",
        label: "Te Addensato",
        videoId: "sflrpg5RbsY",
        duration: "0:58",
        completed: false,
      },
    ],
  },
  {
    key: "cat-3",
    label: "IDDSI 2",
    type: "flat",
    colore: "#EB4785",
    descrizione:
      "Scivola dal cucchiaio. È sorseggiabile, scivola velocemente dal cucchiaio ma più lentamente di una bevanda livello 0-1. Richiede uno sforzo maggiore rispetto i livelli precedenti se assunto con una cannuccia standard (diametro 5.3 mm).",
    test_di_flusso:
      "Utilizzando una siringa di portata 10 mL e lunghezza graduazione 61.5 mm, si fa scorrere il liquido all’interno contando  10 secondi. Allo scadere del tempo il residuo rimasto nella siringa deve essere contenuto tra 4 e 8 mL.",
    consiglio:
      "Per la preparazione della bevanda addensata, può risultare più facile mescolare il tutto con una frusta, in modo da evitare la formazione di grumi. Inoltre  è preferibile preparare delle quantità limitate di bevanda, seppur più scomodo. Infatti, se non  viene consumata nel breve periodo (qualche ora), c’è il rischio che cambi il livello della consistenza.",
    subcategories: [
      {
        key: "3a",
        label: "Te Addensato",
        videoId: "upoZCIMssZw",
        duration: "0:53",
        completed: false,
      },
    ],
  },
  {
    key: "cat-4",
    label: "IDDSI 3",
    type: "nested",
    colore: "#FFED00",
    descrizione:
      "Può essere bevuto da una tazza e richiede un certo sforzo per essere assunto con una cannuccia standard (6.9 mm). Non resta coeso se versato in un piatto e non può essere assunto con una forchetta, perché gocciola lentamente attraverso i rebbi. Può essere assunto con il cucchiaio e non richiede masticazione. Gli alimenti di questa consistenza possono direttamente deglutiti. Ha una struttura omogenea priva di grumi, frammenti di gusci, pelle, bucce, particelle di cartilagine e osso.",
    test_di_flusso:
      "Utilizzando una siringa di portata 10 mL e lunghezza graduazione 61.5 mm, si fa scorrere il liquido all’interno contando 10 secondi. Allo scadere del tempo il residuo rimasto nella siringa deve essere maggiore di 8 mL.",
    test_gocciolamento_forchetta:
      "Utilizzando una forchetta, si preleva e si nota che gocciola lentamente dai rebbi. L’impronta della forchetta non lascia un reticolo netto sulla superficie. Se versato su una superficie piana, si spande. In seguito alla pressione della forchetta, non rimane compatto.",
    test_di_cucchiaio:
      "Utilizzando un cucchiaio, prelevare l’alimento e successivamente farlo scivolare dal cucchiaio. Quanto risulta è che inclinando il cucchiaio, l’alimento si versa facilmente lasciando un residuo minimo.",
    consiglio:
      "Per la preparazione della bevanda addensata, può risultare più facile mescolare il tutto con una frusta, in modo da evitare la formazione di grumi. Inoltre è preferibile preparare delle quantità limitate di bevanda, seppur più scomodo. Infatti, se non  viene consumata nel breve periodo (qualche ora), c’è il rischio che cambi il livello della consistenza.",
    subcategories: [
      {
        key: "4b",
        label: "Bevanda",
        children: [
          {
            key: "4b1",
            label: "Te Addensato",
            duration: "1:12",
            videoId: "2zV-oYSb5y8",
            completed: false,
          },
        ],
      },
      {
        key: "4a",
        label: "Cibo",
        children: [
          {
            key: "4a1",
            label: "Vellutata di Zucca e Carota",
            duration: "1:17",
            videoId: "u3jqlaC6Xeo",
            completed: false,
          },
        ],
      },
    ],
  },
  {
    key: "cat-5",
    label: "IDDSI 4",
    type: "nested",
    colore: "#73B338",
    descrizione:
      "Generalmente si assume con il cucchiaio (possibile anche con la forchetta), non può essere bevuto ne succhiato con una cannuccia, inoltre non richiede masticazione. Mantiene la propria forma. Scivola lentamente per effetto della gravità ma non può essere versato. È privo di grumi e non appiccica. Il liquido non si separa dal solido.",
    test_di_flusso: "non è applicabile.",
    test_gocciolamento_forchetta:
      "Utilizzando una forchetta, si preleva il cibo e si nota che resta ammucchiato sopra la forchetta; una piccola quantità può fluire attraverso i rebbi e formare una piccola appendice ma non scorre o non gocciola.",
    test_di_cucchiaio:
      "Utilizzando un cucchiaio, prelevare l’alimento e successivamente farlo scivolare dal cucchiaio. Si nota che il bolo è abbastanza coeso da mantenere la propria forma all’interno del cucchiaio. Inoltre cade dal cucchiaio inclinato o “a coltello” con minimo movimento dello stesso. Il cibo scivola via facilmente, lasciando una pellicola sottile e trasparente aderente al cucchiaio. Il campione non risulta essere né appiccicoso, né solido.",
    consiglio:
      "Per la preparazione della bevanda addensata, può risultare più facile mescolare il tutto con una frusta, in modo da evitare la formazione di grumi. Inoltre è preferibile preparare delle quantità limitate di bevanda, seppur più scomodo. Infatti, se non  viene consumata nel breve periodo (qualche ora), c’è il rischio che cambi il livello della consistenza. Per quanto riguarda invece la preparazione del cibo, più nello specifico della pasta o riso: si può utilizzare pasta di piccola dimensione (qui sono stati utilizzati i risoni), così da frullare il tutto con maggiore facilità. Inoltre, conviene far cucinare per bene la pasta finchè non è ben morbida e, mentre si frulla, aggiungere olio o brodo per amalgamare la pasta al condimento. L’importante è non creare doppie consistenze, poiché non rientrano nel livello 4",

    subcategories: [
      {
        key: "5a",
        label: "Bevanda",
        children: [
          {
            key: "5a1",
            label: "Tè",
            duration: "0:54",
            videoId: "bSXcaAc2rbI",
            completed: false,
          },
        ],
      },
      {
        key: "5b",
        label: "Cibo",
        children: [
          {
            key: "5b1",
            label: "Crema di Riso con Formaggio e Filo D'olio; Crème Caramel",
            duration: "1:08",
            videoId: "M89JfoUQTys",
            completed: false,
          },
        ],
      },
    ],
  },
  {
    key: "cat-6",
    label: "IDDSI 5",
    type: "flat",
    colore: "#FF6303",
    descrizione:
      "Può essere mangiato con una forchetta o un cucchiaio. In alcuni casi, se la persona ha un ottimo controllo manuale, può essere assunto con le bacchette. Inoltre si può modellare “a polpetta” su un piatto. È morbido e umido senza liquido a parte. In caso di presenza di piccoli grumi visibili all’interno del cibo: Per il bambino, i grumi devono essere di dimensione uguale o inferiore a 2 mm di larghezza e non più lungo di 8 mm. I grumi sono facilmente schiacciabili con la lingua.Un cibo per poter rientrare nel livello 5, deve superare almeno tre test:",
    test_pressione_forchetta:
      "Sotto la pressione della forchetta, le particelle di separano e attraversano i rebbi. Quindi il campione è facilmente schiacciabile con una minima pressione della forchetta.",
    test_gocciolamento_forchetta:
      "Il cibo rimane sulla forchetta senza correre attraverso i rebbi.",
    test_di_cucchiaio:
      "Utilizzando un cucchiaio, prelevare l’alimento e successivamente farlo scivolare dal cucchiaio. Si nota che il bolo è abbastanza coeso da mantenere la propria forma all’interno del cucchiaio. Inoltre scivola a blocco dal cucchiaio inclinato o se lievemente scocco lascia un residuo minimo. Il campione non risulta essere appiccicoso e può diffondersi leggermente se versato nel piatto.",
    consiglio:
      "Durante la preparazione di un pasto tritato fine e umido, possono essere utili alcuni utensili o supporti da cucina. Innanzitutto per sminuzzare il cibo: grattugia, tritacarne elettrico, schiaccia patate, infine anche la forbice masticatoria. Tutti questi hanno diverse misure per tritare il cibo, quindi possono facilitare l’intera preparazione. Infine sono efficaci olio e brodo, che contribuiscono ad ammorbidire le pietanze durante la cottura. L’importante è non creare doppie consistenze, poiché non rientrano nel livello 5.Per capire la dimensione che devono avere i pezzi→ vedi foto di riferimento. ",
    immagine_di_riferimento: "/assets/ragu.png",

    subcategories: [
      {
        key: "6a",
        label: "Macinato di Manzo con Zucchine e Carote",
        duration: "0:54",
        videoId: "OTLajCPa1P4",
        completed: false,
      },
    ],
  },
  {
    key: "cat-7",
    label: "IDDSI 6",
    type: "flat",
    colore: "#0864C1",
    descrizione:
      "Può essere assunto con la forchetta, il cucchiaio oppure le bacchette. Può essere schiacciato con la pressione della forchetta, del cucchiaio o delle bacchette. Infatti per tagliare questo cibo non è necessario il coltello, bastano cucchiaio o forchetta. Si tratta dunque di una consistenza morbida e tenera, non doppie consistenze.  È necessario che il cibo venga masticato prima di poter essere deglutito. Infine la dimensione dei pezzetti va in relazione a età ed abilità del paziente. Nel caso dei bambini, i pezzetti non devono essere maggiori di 8 mm.",
    test_pressione_forchetta:
      "Utilizzando una forchetta in posizione di taglio è possibile ridurre il campione. Poi facendo pressione sulla base della forchetta (fino a notare il biancore dell’unghia) si valuta se il campione si schiaccia, frantuma, senza che riprenda la forma originale.",
    test_pressione_cucchiaio:
      "Utilizzando un cucchiaio in posizione di taglio è possibile ridurre il campione. Poi facendo pressione sul dorso del cucchiaio si valuta se il campione si deforma, senza che riprenda la forma originale.",
    consiglio:
      "Prima della consumazione, è possibile spezzettare il cibo con le forbici masticatorie, in alternativa agli utensili come forchetta e coltello. L’utilizzo di olio per mantenere morbida la pietanza è sempre consigliato. L’importante è non creare doppie consistenze, poiché non rientrano nel livello 6.",
    immagine_di_riferimento: "/assets/banana_schiacciata.png",

    subcategories: [
      {
        key: "7a",
        label: "Frittata e Avocado",
        videoId: "V8ChVskx68w",
        duration: "1:07",
        completed: false,
      },
    ],
  },
  {
    key: "cat-8",
    label: "IDDSI 7",
    type: "flat",
    colore: "#000",
    descrizione:
      "Si tratta di alimenti normali di consistenza tenera, adatti allo sviluppo evolutivo e all’età. Si può utilizzare qualsiasi strumento per assumere l’alimento. Non ci sono restrizioni relative alla dimensione.È importante ricordare che la seguente consistenza non include: pezzetti duri, semi, buccia e parti fibrose di frutta/verdura. Non lische, parti fibrose, gommose, cartilaginee, croccanti, friabili. Questo livello può includere cibi e liquidi a consistenza mista, se c’è la sicurezza clinica per il livello 0. In caso contrario, si dovrà addensare la parte liquida, secondo raccomandazione clinica.",
    test_pressione_forchetta:
      "Utilizzando una forchetta in posizione di taglio è possibile ridurre il campione. Poi facendo pressione sulla base della forchetta (fino a notare il biancore dell’unghia) si valuta se il campione si schiaccia, frantuma, senza che riprenda la forma originale. ",
    test_pressione_cucchiaio:
      "Utilizzando un cucchiaio in posizione di taglio è possibile ridurre il campione. Poi facendo pressione sul dorso del cucchiaio si valuta se il campione si deforma, senza che riprenda la forma originale.",
    consiglio:
      "Assicurarsi che le pietanze preparate risultino morbide e ben lubrificate, evitando consistenze asciutte o viscose. Quindi può essere utile aggiungere condimenti, come oli vegetali (ad esempio olio extravergine d'oliva) o altri ingredienti con la stessa finalità.   Infine, si consiglia sempre di adattare dimensione dei cibi alle capacità di masticazione del bambino/a, seguendo attentamente le indicazioni fornite dalla terapista di riferimento.",
    subcategories: [
      {
        key: "8a",
        label: "Pasta al Pomodoro con Formaggio",
        duration: "1:12",
        videoId: "DWM69k-G0W4",
        completed: false,
      },
    ],
  },
];

// ── Helpers ──────────────────────────────────────────────────────────────────
function findLesson(leafKey) {
  for (const cat of CATEGORIES) {
    if (cat.type === "nested") {
      for (const sub of cat.subcategories) {
        for (const leaf of sub.children) {
          if (leaf.key === leafKey) return { cat, sub, lesson: leaf };
        }
      }
    } else {
      for (const sub of cat.subcategories) {
        if (sub.key === leafKey) return { cat, sub: null, lesson: sub };
      }
    }
  }
  return null;
}

function totalLessons() {
  let n = 0;
  for (const cat of CATEGORIES) {
    if (cat.type === "nested") {
      for (const sub of cat.subcategories) n += sub.children.length;
    } else {
      n += cat.subcategories.length;
    }
  }
  return n;
}

function completedLessons() {
  let n = 0;
  for (const cat of CATEGORIES) {
    if (cat.type === "nested") {
      for (const sub of cat.subcategories)
        n += sub.children.filter((l) => l.completed).length;
    } else {
      n += cat.subcategories.filter((s) => s.completed).length;
    }
  }
  return n;
}

// ── Video Player ─────────────────────────────────────────────────────────────
function VideoPlayer({ title, duration, videoId }) {
  const [playing, setPlaying] = useState(false);
  const src = `https://www.youtube.com/embed/${videoId || "ysz5S6PUM-U"}?rel=0&controls=0&showinfo=0&modestbranding=1${playing ? "&autoplay=1" : ""}`;

  return (
    <div
      onClick={() => setPlaying(true)}
      style={{
        background:
          "linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)",
        borderRadius: 12,
        aspectRatio: "16/9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        marginBottom: 20,
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <iframe
        title={title}
        width="100%"
        height="100%"
        src={src}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ border: "none", flex: 1 }}
      />
      {!playing && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.35)",
          }}
        >
          <PlayCircleOutlined
            style={{ fontSize: 56, color: "#fff", opacity: 0.95 }}
          />
        </div>
      )}
    </div>
  );
}

// ── Lesson View ──────────────────────────────────────────────────────────────
function LessonView({ leafKey }) {
  const found = findLesson(leafKey);
  if (!found)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: 300,
          color: "#aaa",
        }}
      >
        <PlayCircleOutlined
          style={{ fontSize: 40, marginBottom: 12, color: "#f9b27f" }}
        />
        <Text type="secondary">Seleziona una lezione dalla barra laterale</Text>
      </div>
    );

  const { cat, sub, lesson } = found;
  const breadcrumbs = [
    { title: cat.label },
    ...(sub ? [{ title: sub.label }] : []),
    { title: lesson.label },
  ];

  const tabItems = [
    {
      key: "lesson",
      label: (
        <Space>
          <VideoCameraOutlined />
          Lezione
        </Space>
      ),
      children: (
        <>
          <VideoPlayer
            title={lesson.label}
            duration={lesson.duration}
            videoId={lesson.videoId}
          />
          <Typography>
            <Paragraph>
              <span style={{ fontWeight: "bold" }}>Descrizione: </span>{" "}
              {cat.descrizione}
            </Paragraph>

            {cat.test_di_flusso ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>Test di flusso:</span>
                {cat.test_di_flusso}
              </Paragraph>
            ) : null}

            {cat.test_pressione_forchetta ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>
                  Test di pressione della forchetta:{" "}
                </span>
                {cat.test_pressione_forchetta}
              </Paragraph>
            ) : null}
            {cat.test_gocciolamento_forchetta ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>
                  Test di gocciolamento dalla forchetta:{" "}
                </span>
                {cat.test_gocciolamento_forchetta}
              </Paragraph>
            ) : null}
            {cat.test_di_cucchiaio ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>
                  Test del cucchiaio inclinato:{" "}
                </span>
                {cat.test_di_cucchiaio}
              </Paragraph>
            ) : null}
            {cat.test_pressione_cucchiaio ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>
                  Test di pressione del cucchiaio:{" "}
                </span>
                {cat.test_pressione_cucchiaio}
              </Paragraph>
            ) : null}
            {cat.consiglio ? (
              <Paragraph>
                <span style={{ fontWeight: "bold" }}>Consiglio: </span>
                {cat.consiglio}
              </Paragraph>
            ) : null}
          </Typography>
          {cat.immagine_di_riferimento ? (
            <img
              src={cat.immagine_di_riferimento}
              alt={cat.label}
              style={{ maxWidth: "200px", height: "auto", marginTop: 16 }}
            />
          ) : null}
        </>
      ),
    },
  ];

  return (
    <div style={{ maxWidth: 820 }}>
      <Breadcrumb items={breadcrumbs} style={{ marginBottom: 14 }} />
      <div style={{ marginBottom: 18 }}>
        <Title level={4} style={{ marginBottom: 8 }}>
          {lesson.label}
        </Title>
        <Space size={10} wrap>
          <Tag
            color="orange"
            icon={<VideoCameraOutlined />}
            style={{ borderRadius: 20 }}
          >
            Video + Lettura
          </Tag>
          <Text type="secondary" style={{ fontSize: 12 }}>
            <ClockCircleOutlined style={{ marginRight: 4 }} />
            {lesson.duration}
          </Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            · {cat.label}
          </Text>
          {lesson.completed && (
            <Tag
              color="success"
              icon={<CheckCircleFilled />}
              style={{ borderRadius: 20 }}
            >
              Completata
            </Tag>
          )}
        </Space>
      </div>
      <Tabs defaultActiveKey="lesson" items={tabItems} />
    </div>
  );
}

// ── Sidebar Nav ───────────────────────────────────────────────────────────────
function SidebarNav({ activeKey, onSelect }) {
  const [openCats, setOpenCats] = useState(["cat-1"]);
  const [openSubs, setOpenSubs] = useState({});

  const toggleCat = (key) =>
    setOpenCats((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );

  const toggleSub = (key) =>
    setOpenSubs((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div style={{ overflowY: "auto", height: "100%", paddingBottom: 16 }}>
      {CATEGORIES.map((cat, idx) => {
        const isOpen = openCats.includes(cat.key);
        return (
          <div key={cat.key}>
            {/* Category header */}
            <div
              onClick={() => toggleCat(cat.key)}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 16px",
                cursor: "pointer",
                background: isOpen ? "#ff8c0077" : "transparent",
                borderLeft: `3px solid ${cat.colore}`,

                transition: "all 0.15s",
              }}
            >
              <div
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",

                  color: isOpen ? "#fff" : "#888",
                  fontSize: 11,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  marginRight: 10,
                }}
              >
                <img
                  src={`/assets/cat${idx}.jpg`}
                  alt=""
                  style={{ width: 12 }}
                />
              </div>
              <Text
                strong={isOpen}
                style={{
                  fontSize: 13,
                  flex: 1,
                  color: isOpen ? cat.colore : undefined,
                }}
              >
                {cat.label}
              </Text>
              <RightOutlined
                style={{
                  fontSize: 10,
                  color: "#bbb",
                  transform: isOpen ? "rotate(90deg)" : "none",
                  transition: "transform 0.2s",
                }}
              />
            </div>

            {/* Subcategories */}
            {isOpen && (
              <div>
                {cat.type === "flat"
                  ? cat.subcategories.map((sub) => (
                      <div
                        key={sub.key}
                        onClick={() => onSelect(sub.key)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "7px 16px 7px 36px",
                          cursor: "pointer",
                          background:
                            activeKey === sub.key ? "#fff3e8" : "transparent",
                          borderLeft:
                            activeKey === sub.key
                              ? "3px solid #f9b27f"
                              : "3px solid transparent",
                          transition: "background 0.12s",
                        }}
                      >
                        {sub.completed ? (
                          <CheckCircleFilled
                            style={{
                              color: "#52c41a",
                              fontSize: 11,
                              marginRight: 8,
                              flexShrink: 0,
                            }}
                          />
                        ) : (
                          <PlayCircleOutlined
                            style={{
                              color: "#ccc",
                              fontSize: 11,
                              marginRight: 8,
                              flexShrink: 0,
                            }}
                          />
                        )}
                        <Text
                          style={{
                            fontSize: 12,
                            flex: 1,
                            color:
                              activeKey === sub.key ? "#ff8c00" : undefined,
                          }}
                        >
                          {sub.label}
                        </Text>
                        <Text
                          type="secondary"
                          style={{ fontSize: 11, flexShrink: 0 }}
                        >
                          {sub.duration}
                        </Text>
                      </div>
                    ))
                  : cat.subcategories.map((sub) => (
                      <div key={sub.key}>
                        {/* L2 toggle */}
                        <div
                          onClick={() => toggleSub(sub.key)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "7px 16px 7px 36px",
                            cursor: "pointer",
                            background: openSubs[sub.key]
                              ? "#fafafa"
                              : "transparent",
                          }}
                        >
                          <FolderOutlined
                            style={{
                              color: "#f9b27f",
                              fontSize: 12,
                              marginRight: 8,
                            }}
                          />
                          <Text
                            strong
                            style={{ fontSize: 12, flex: 1, color: "#555" }}
                          >
                            {sub.label}
                          </Text>
                          <RightOutlined
                            style={{
                              fontSize: 9,
                              color: "#bbb",
                              transform: openSubs[sub.key]
                                ? "rotate(90deg)"
                                : "none",
                              transition: "transform 0.2s",
                            }}
                          />
                        </div>
                        {/* L3 leaves */}
                        {openSubs[sub.key] &&
                          sub.children.map((leaf) => (
                            <div
                              key={leaf.key}
                              onClick={() => onSelect(leaf.key)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px 6px 52px",
                                cursor: "pointer",
                                background:
                                  activeKey === leaf.key
                                    ? "#fff3e8"
                                    : "transparent",
                                borderLeft:
                                  activeKey === leaf.key
                                    ? "3px solid #f9b27f"
                                    : "3px solid transparent",
                                transition: "background 0.12s",
                              }}
                            >
                              {leaf.completed ? (
                                <CheckCircleFilled
                                  style={{
                                    color: "#52c41a",
                                    fontSize: 10,
                                    marginRight: 8,
                                    flexShrink: 0,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: 5,
                                    height: 5,
                                    borderRadius: "50%",
                                    background:
                                      activeKey === leaf.key
                                        ? "#ff8c00"
                                        : "#ddd",
                                    marginRight: 10,
                                    flexShrink: 0,
                                  }}
                                />
                              )}
                              <Text
                                style={{
                                  fontSize: 12,
                                  flex: 1,
                                  color:
                                    activeKey === leaf.key
                                      ? "#ff8c00"
                                      : undefined,
                                }}
                              >
                                {leaf.label}
                              </Text>
                              <Text
                                type="secondary"
                                style={{ fontSize: 11, flexShrink: 0 }}
                              >
                                {leaf.duration}
                              </Text>
                            </div>
                          ))}
                      </div>
                    ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
const Logopedista = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [activeLesson, setActiveLesson] = useState("1a");
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const total = totalLessons();
  const done = completedLessons();
  const percent = Math.round((done / total) * 100);

  const sidebarWidth = screens.md ? 280 : "100%";
  const isMobile = !screens.md;

  return (
    <Space direction="vertical" size={0} style={{ width: "100%" }}>
      {/* ── Header (preserved exactly) ── */}
      <div
        style={{
          background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
          height: 100,
          maxHeight: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",
          position: "relative",
          flexShrink: 0,
        }}
      >
        <Button
          type="text"
          onClick={() => navigate("/PappaTime")}
          icon={<CaretLeftOutlined />}
          aria-label="Home"
          style={{
            position: "absolute",
            left: 16,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#fff",
            fontSize: 20,
          }}
        >
          {" "}
          Back{" "}
        </Button>
        <div style={{ alignItems: "center", justifyContent: "center" }}>
          <Title
            level={1}
            style={{ color: "#fff", letterSpacing: "-0.4px", margin: 0 }}
          >
            Logopedista
          </Title>
        </div>
        {/* Progress pill — top right */}
      </div>

      {/* ── Body: sidebar + content ── */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          minHeight: "calc(100vh - 100px)",
          background: "#fafafa",
        }}
      >
        {/* Sidebar */}
        <div
          style={{
            width: isMobile ? "100%" : 280,
            minWidth: isMobile ? "100%" : 280,
            background: "#fff",
            borderRight: isMobile ? "none" : "1px solid #f0f0f0",
            borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Sidebar header */}
          <div
            style={{
              padding: "14px 16px 10px",
              borderBottom: "1px solid #f5f5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              type="secondary"
              style={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                fontWeight: 500,
              }}
            >
              Contenuto del corso
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              {total} lezioni
            </Text>
          </div>
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              maxHeight: isMobile ? 340 : undefined,
            }}
          >
            <SidebarNav activeKey={activeLesson} onSelect={setActiveLesson} />
          </div>
        </div>

        {/* Content */}
        <div
          style={{
            flex: 1,
            padding: isMobile ? "20px 16px" : "28px 36px",
            overflowY: "auto",
          }}
        >
          <LessonView leafKey={activeLesson} />
        </div>
      </div>
    </Space>
  );
};

export default Logopedista;
